/**
 * BrightPath - Budget Types
 * BP-04-04: Expenses Frontend
 */

import type { ExpenseCategory } from './expenseTypes';

export interface Budget {
  id: string;
  familyId: string;
  category: ExpenseCategory;
  monthlyBudget: number;
  year: number;
  month: number;
  alertThreshold: number; // Percentage (0-100)
  createdAt: string;
  updatedAt: string;
}

export interface BudgetCreate {
  category: ExpenseCategory;
  monthlyBudget: number;
  year: number;
  month: number;
  alertThreshold?: number;
}

export interface BudgetUpdate {
  monthlyBudget?: number;
  alertThreshold?: number;
}

export interface BudgetStatus {
  budget: Budget;
  spent: number;
  remaining: number;
  percentageUsed: number;
  isOverBudget: boolean;
  isNearThreshold: boolean;
  projectedMonthEnd: number;
  daysRemaining: number;
}

export interface BudgetListParams {
  year?: number;
  month?: number;
  category?: ExpenseCategory;
}

export interface BudgetSummary {
  totalBudgeted: number;
  totalSpent: number;
  totalRemaining: number;
  overallPercentage: number;
  budgets: BudgetStatus[];
}

export interface BudgetTrend {
  year: number;
  month: number;
  budgeted: number;
  spent: number;
  variance: number;
}

// Helper to get current year/month
export const getCurrentBudgetPeriod = (): { year: number; month: number } => {
  const now = new Date();
  return {
    year: now.getFullYear(),
    month: now.getMonth() + 1,
  };
};

// Format month/year for display
export const formatBudgetPeriod = (year: number, month: number): string => {
  const date = new Date(year, month - 1);
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};

